import connectedStore from '../../store/connected-store';

const isVisible = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return Boolean(state.ws.dialogs.type);
};

export default isVisible;
